export const getError = (error) => {
  const defaultErrorMessage = "API Error, please try again.";

  // Check if the error has a response property
  if (!error.response) {
    const url = error.config ? error.config.url : 'unknown';
    console.error(`API request to ${url} failed: No response received.`);
    console.error("Error Object Details:", error); // Log the entire error object
    return `${defaultErrorMessage} Error: No response from the server.`;
  }

  // Log detailed error information in development mode
  if (process.env.NODE_ENV === "development") {
    console.error("Error Response Data:", error.response.data);
    console.error("Error Status:", error.response.status);
    console.error("Error Headers:", error.response.headers);
    console.error("Error Config:", error.config); // Log the request configuration
  }

  // Check if the error response contains specific error messages
  if (error.response.data && error.response.data.errors) {
    if (typeof error.response.data.errors === 'string') {
      return `Error: ${error.response.data.errors}`; // If it's a single error message
    } else if (Array.isArray(error.response.data.errors)) {
      return `Errors: ${error.response.data.errors.join(", ")}`; // Join array of messages
    } else if (typeof error.response.data.errors === 'object') {
      const errorMessages = Object.values(error.response.data.errors).flat().join(", ");
      return `Errors: ${errorMessages}`;
    }
  }

  // Log general error information if specific messages are not found
  const status = error.response.status;
  const statusText = error.response.statusText || 'Unknown error';
  console.error(`API request failed with status ${status} (${statusText}).`);

  return `${defaultErrorMessage} Error: ${status} (${statusText})`;
};

